import PatientsReassignmentForm from './PatientsReassignmentForm';

export default PatientsReassignmentForm;
